import { AdjustableColorLegend } from '@/components/colorLegend/AdjustableColorLegend';
import { ColorLegend } from '@/components/colorLegend/ColorLegend';
import type { JSONConfig } from '@/engine/app/interfaces';
import type { ViewHelper } from '@/engine/app/models/viewEntity/view.entity.ts';
import { ReactComponent as MaximizeIcon } from '@/engine/app/modules/images/assets/largescreen.svg';
import { ReactComponent as MaximizeIconBlack } from '@/engine/app/modules/images/assets/largescreen.black.svg';

export const renderColorLegend = (helpers: Array<ViewHelper>): JSX.Element | null => {
  const colorLegend = helpers.find((h) => h.descriptor === 'color_legend');
  const details = colorLegend?.details;

  if (!details) {
    return null;
  }

  const valueDetails = details as JSONConfig.ValueColorLegendHelper;
  if (valueDetails.value) {
    return <AdjustableColorLegend {...valueDetails} />;
  }

  return <ColorLegend {...colorLegend?.details} />;
};

export const renderMaximizeIconContrast = (mode: 'light' | 'dark' | 'report'): JSX.Element => {
  const MaximizeIconContrast = mode === 'light' || mode === 'report' ? MaximizeIconBlack : MaximizeIcon;

  return <MaximizeIconContrast style={{ width: '30px', height: '30px' }} data-testid={'maximize-3d'} />;
};
